module.exports = __webpack_public_path__ + "static/main-1e2daef1d1db26f3c619f4a47b9d4208.jpg";